import stylePoints from "./ButtonContainer.module.scss";
import classNames from "classnames";
import "../../../index.scss";
import { useTranslation } from "react-i18next";

interface IProps {
  saveButton: () => void,
  cancelButton?: () => void, 
  saveTxt?: string,
  cancelTxt?: string,
  isValidSaveButton?: boolean,
  isSaveTransparent?: boolean,
  margin?: string,
  customClass?: string
}

const ButtonContainer = ({
    saveButton,
    isValidSaveButton = true,
    saveTxt = null,
    cancelTxt = null,
    cancelButton = null,
    isSaveTransparent = false,
    margin = "",
    customClass= "" 
  }: IProps) => {
  const { t } = useTranslation();
  
  return (
    <div style={{margin}} className={classNames(stylePoints.acc_button_cont, customClass)}>
      {cancelButton &&
        <button
          onClick={cancelButton}
          className={"transparent_btn_big"}
        >
          { cancelTxt || t("comman_word.cancel_text") }
        </button>
      }

      <button
        disabled={!isValidSaveButton}
        onClick={saveButton}
        className={ isSaveTransparent
          ? classNames("transparent_btn_big")
          : "main_btn"
        }
      >
        { saveTxt 
          ? t(saveTxt) 
          : t("comman_word.save_text")
        }
      </button> 
    </div>
  );
};

export default  ButtonContainer;
